// src/pages/GalleryPage.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from '../components/Layout/Layout';

const GalleryPage = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const response = await axios.get('http://localhost:5000/gallery');
        setImages(response.data);
      } catch (err) {
        setError('Failed to fetch gallery images. Please try again later.');
        console.error('Error fetching gallery:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchGallery();
  }, []);

  return (
    <Layout>
      <div className="page-container" style={{ maxWidth: '1200px', margin: '40px auto', padding: '0 20px' }}>
        <h2 style={{ color: 'var(--primary-blue)', borderBottom: '2px solid var(--light-blue)', paddingBottom: '10px', marginBottom: '30px' }}>
          Photo Gallery
        </h2>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>Loading images...</div>
        ) : error ? (
          <div style={{ color: 'red', textAlign: 'center', padding: '40px' }}>{error}</div>
        ) : images.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: 'var(--text-muted)' }}>
            No images currently available in the gallery.
          </div>
        ) : (
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', 
            gap: '20px' 
          }}>
            {images.map((img) => (
              <div key={img._id} style={{ 
                backgroundColor: '#fff', 
                borderRadius: '8px', 
                overflow: 'hidden',
                boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                transition: 'transform 0.2s',
                cursor: 'pointer'
              }}
              onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
              onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
              >
                <div style={{ 
                  width: '100%', 
                  height: '200px', 
                  backgroundColor: '#eee',
                  backgroundImage: `url(${img.imageUrl})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }} />
                <div style={{ padding: '15px' }}>
                  <h4 style={{ color: 'var(--primary-blue)', marginBottom: '5px' }}>{img.title}</h4>
                  {img.description && <p style={{ fontSize: '0.85rem', color: '#666' }}>{img.description}</p>}
                  <span style={{ 
                    display: 'inline-block', 
                    marginTop: '10px', 
                    padding: '3px 8px', 
                    backgroundColor: 'var(--light-blue)', 
                    color: 'var(--primary-blue)', 
                    borderRadius: '12px', 
                    fontSize: '0.75rem',
                    fontWeight: 500
                  }}>
                    {img.category.replace('_', ' ').toUpperCase()}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default GalleryPage;
